// This file is automatically generated. DO NOT EDIT, all your changes would be lost.
import React from 'react';
var CheckIcon = /*#__PURE__*/React.memo(({
  className,
  style
}) => /*#__PURE__*/React.createElement("svg", {
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg",
  style: style,
  className: className
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.257 3.331a1 1 0 011.564 1.24l-.078.098-9 10a1 1 0 01-1.36.118l-.09-.08-5-5a1 1 0 011.32-1.497l.094.083 4.255 4.254 8.295-9.216z",
  fill: "currentcolor"
})));
export default CheckIcon;